import {
  MOON_250,
  MOON_400,
  MOON_500,
  MOON_600,
  MOON_650,
  MOON_800,
  TEAL_500,
  TEAL_600,
} from '@wandb/weave/common/css/color.styles';
import {Link} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const PopoverContainer = styled.div`
  font-family: 'Source Sans Pro';
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 10px;
  margin-right: 16px;
  width: 875px;
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(13, 15, 18, 0.16);
  border-radius: 4px;
  border: 1px solid #DFE0E2;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  height: 32px;
`;

export const HeaderTitle = styled.h3`
  height: 32px;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  color: ${MOON_800};
  margin: 0;
`;

export const TableContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  border: 1px solid ${MOON_250};
  border-radius: 4px;
  width: 100%;
`;

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
`;

export const TableRow = styled.div<{isExpanded?: boolean}>`
  display: grid;
  grid-template-columns: 100px 1fr 1fr 1fr 48px 80px;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: 0 16px;
  background: #ffffff;
  gap: 8px;

  &:hover {
    background: linear-gradient(
        0deg,
        rgba(13, 15, 18, 0.03),
        rgba(13, 15, 18, 0.03)
      ),
      #ffffff;
  }
`;

export const TableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 1fr 1fr 48px 80px;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: 0 16px;
  background: #0D0F1205;
  gap: 8px;
  border-bottom: 1px solid ${MOON_250};
`;

export const TableHeaderCell = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${MOON_650};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 40px;
`;

export const TimeColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 140%;
  color: ${MOON_500};
  height: 40px;
`;

export const RunColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: ${MOON_500};
  min-width: 0;
  overflow: hidden;
`;

export const QueueColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: ${MOON_600};
  min-width: 0;
  overflow: hidden;
`;

export const ProjectColumn = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: ${MOON_600};
  min-width: 0;
  overflow: hidden;
`;

export const RunLink = styled(Link)`
  color: ${TEAL_600};
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: ${TEAL_500};
  }
`;

export const ClickableText = styled.span`
  cursor: pointer;
  color: inherit;
  font-weight: inherit;

  &:hover {
    color: ${MOON_400};
  }
`;

export const StatusColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 4px;
  height: 40px;
`;

export const LeaderboardColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  height: 40px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px;
  height: 40px;
  background: #ffffff;
  border-top: 1px solid ${MOON_250};
  gap: 16px;
  width: 100%;
`;

export const PaginationText = styled.span`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: ${MOON_650};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
`;

export const LoadingContainer = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
`;

export const EmptyStateContainer = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  color: ${MOON_500};
`;
